'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuButton = function (_Component) {
  _inherits(QuButton, _Component);

  function QuButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, QuButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuButton.__proto__ || Object.getPrototypeOf(QuButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      if (_this.props.disabled) {
        event.preventDefault();
        return false;
      }
      return _this.props.onClick(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(QuButton, [{
    key: 'className',
    value: function className(type, disabled, children, _className, fluid, size) {
      return (0, _classnames2.default)(['qu-button', _className, 'var-' + type, {
        fluid: fluid,
        'is-disabled': disabled,
        'is-empty': !children,
        'is-small': size === 'small',
        'is-normal': size === 'normal',
        'is-large': size === 'large'
      }]);
    }

    /*
      Separate div needed to cause the timed look
      Each div has a different animation delay,
      border color is set for only one side of each div.
    */

  }, {
    key: 'renderLoadingIcon',
    value: function renderLoadingIcon(loading) {
      if (!loading) return '';
      return _react2.default.createElement(
        'div',
        { className: 'loader' },
        _react2.default.createElement('div', null),
        _react2.default.createElement('div', null),
        _react2.default.createElement('div', null),
        _react2.default.createElement('div', null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          disabled = _props.disabled,
          loading = _props.loading,
          children = _props.children,
          className = _props.className,
          size = _props.size,
          fluid = _props.fluid,
          buttonType = _props.buttonType,
          others = _objectWithoutProperties(_props, ['type', 'disabled', 'loading', 'children', 'className', 'size', 'fluid', 'buttonType']);

      return _react2.default.createElement(
        'button',
        _extends({
          className: this.className(type, disabled, children, className, fluid, size),
          type: buttonType
        }, others, {
          onClick: this.onClick
        }),
        this.renderLoadingIcon(loading),
        _react2.default.createElement(
          'span',
          { className: 'button-text' },
          children
        )
      );
    }
  }]);

  return QuButton;
}(_react.Component);

QuButton.propTypes = {
  children: _propTypes2.default.node,
  type: _propTypes2.default.oneOf(['default', 'primary', 'secondary', 'transparent', 'link', 'flat', 'flat-primary', 'danger']),
  disabled: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  fluid: _propTypes2.default.bool,
  buttonType: _propTypes2.default.oneOf(['submit', 'reset', 'button']),
  size: _propTypes2.default.oneOf(['small', 'normal', 'large'])
};

QuButton.defaultProps = {
  className: '',
  type: 'default',
  disabled: false,
  loading: false,
  fluid: false,
  onClick: function onClick() {
    return null;
  },
  size: 'normal'
};

exports.default = QuButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-button/index.js
// module id = 457
// module chunks = 0